/**
 * Quick View picker — client-side category filter.
 *
 * The picker's navigation (menu -> category -> back) is entirely server-driven
 * via .btn-turbo links, so this file has NO transport logic. It only filters the
 * A-Z category list that Bridge injects into #quickPickerBody, matching the site's
 * existing A-Z mega-menu behaviour (keyword substring match).
 *
 * Delegated because the search input is injected into the modal after load.
 * (Remove this file + the .quick-picker-search input to drop search entirely.)
 */
window.myjQuery(document).ready(function ($) {

  $('body').on('input', '.quick-picker-search', function () {

    var term = $(this).val().trim().toLowerCase();
    var $picker = $(this).closest('.quick-picker');

    // Empty query: restore everything.
    if (!term.length) {
      $picker.find('.picker-list li').show();
      $picker.find('.picker-letter').show();
      $picker.find('.quick-picker-noresults').hide();
      return;
    }

    var anyVisible = false;

    // Letter-group visibility from a per-group match tally, never :visible —
    // items inside a hidden group are :hidden regardless of their own display,
    // so a :visible check goes stale after any zero-result search and the
    // groups would never come back.
    $picker.find('.picker-letter').each(function () {
      var matches = 0;

      $(this).find('.picker-cat').each(function () {
        var keywords = ($(this).attr('keywords') || '').toLowerCase();
        var match = keywords.indexOf(term) !== -1;
        $(this).closest('li').toggle(match);
        if (match) {
          matches++;
        }
      });

      $(this).toggle(matches > 0);
      if (matches > 0) {
        anyVisible = true;
      }
    });

    $picker.find('.quick-picker-noresults').toggle(!anyVisible);
  });

});
